/* eslint-disable no-prototype-builtins */
import React, { useState, useCallback, useEffect, useRef } from 'react'
import axios from 'axios'
import { useNavigate, useParams } from 'react-router-dom'
import { useDrag, useDrop } from 'react-dnd'

import Card from '@mui/material/Card'
import CardHeader from '@mui/material/CardHeader'
import CardMedia from '@mui/material/CardMedia'
import CardContent from '@mui/material/CardContent'
import CardActions from '@mui/material/CardActions'
import Collapse from '@mui/material/Collapse'
import Avatar from '@mui/material/Avatar'
import IconButton from '@mui/material/IconButton'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { Link } from '@mui/material'
import StarIcon from '@mui/icons-material/Star'
import SendIcon from '@mui/icons-material/Send'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import DragIndicatorIcon from '@mui/icons-material/DragIndicator'

import { ExpandMore } from '../../../../helpers/cardHelpers'
import { getPayload, getTokenFromLocalStorage, userIsAuthenticated } from '../../../../helpers/storage'
import { positionChangeHeightSm, positionChangeWidthSm, swipelyticsPink, swipelyticsTurquoise } from '../../../../helpers/variableDefaults'
import useWindowDimensions from '../../../../helpers/windowDimensions'
import { modifyInDatabase } from '../../../../helpers/modifyInDatabase'
import { dragAndDropIconElement } from '../../../../helpers/buttons'
import { standardErrorContainer } from '../../../../helpers/errors'
import { returnVideoThumbnailFromLiveURL, returnDurationFromLiveURL } from '../../../../helpers/imageHandling'
import { handleSetVideoThumbnailDatingProfile } from '../../../../helpers/commonMethods'

const EditMediaItem = ({ mediaItem, mediaItemDimension, datingProfile, setDatingProfile, mediaItemIndex, loading, tapDisabled, handleSelectItem, handleDeleteItem, openMediaItemSelectModal }) => {
  
  // Window Dimensions
  const { height, width } = useWindowDimensions()

  // Payload
  const payload = getPayload()

  // Navigate
  const navigate = useNavigate()

  // Params
  const { estateId, personId } = useParams()

  // URL Path
  const urlPath = window.location.pathname

  // Edit Item Error
  const [editItemError, setEditItemError] = useState(false)

  // Video Handling
  const [videoDuration, setVideoDuration] = useState(-1)
  const [videoThumbnail, setVideoThumbnail] = useState('')
  const [videoItemShouldReload, setVideoItemShouldReload] = useState(false)

  useEffect(() => {
    // console.log('EditMediaItemCard useEffect runs')
    // console.log('datingProfile ->', datingProfile.media[mediaItemIndex].mediaType)
    const getData = async () => {
      await handleSetVideoThumbnailDatingProfile(datingProfile, mediaItemIndex, setVideoThumbnail, setVideoDuration)
    }

    if (datingProfile.media[mediaItemIndex].mediaType === 'video') {
      getData()
    }

  }, [])



  useEffect(() => {
    // console.log('useEffect Runs')
    // console.log('videoThumbnail ->', videoThumbnail)

  }, [videoThumbnail])

  useEffect(() => {
    // console.log('useEffect Runs video item should reload')
    // console.log('videoThumbnail ->', videoThumbnail)

    if (
      datingProfile.media[mediaItemIndex].mediaType === 'video'
      &&
      !(
        'mediaItemThumbnail' in datingProfile.media[mediaItemIndex]
        && 'mediaItemDuration' in datingProfile.media[mediaItemIndex]
      )
    ) {
      // returnVideoThumbnailFromLiveURL(datingProfile.media[mediaItemIndex].mediaItemURL, setVideoThumbnail, setVideoDuration)
      if (
        'mediaItemThumbnail' in datingProfile.media[mediaItemIndex] && datingProfile.media[mediaItemIndex].mediaItemThumbnail.length > 0 && datingProfile.media[mediaItemIndex].mediaItemThumbnail !== 'NA'
        && 'mediaItemDuration' in datingProfile.media[mediaItemIndex]
      ) {
        console.log('thumbnail and duration in media item')
        setVideoDuration(datingProfile.media[mediaItemIndex].mediaItemDuration)
        setVideoThumbnail(datingProfile.media[mediaItemIndex].mediaItemThumbnail)
      } else if (
        'mediaItemThumbnail' in datingProfile.media[mediaItemIndex] && datingProfile.media[mediaItemIndex].mediaItemThumbnail.length > 0 && datingProfile.media[mediaItemIndex].mediaItemThumbnail !== 'NA'
      ) {
        console.log('thumbnail but not duration in media item')
        returnDurationFromLiveURL(datingProfile.media[mediaItemIndex].mediaItemURL, setVideoDuration)
        setVideoThumbnail(datingProfile.media[mediaItemIndex].mediaItemThumbnail)
      } else {
        returnVideoThumbnailFromLiveURL(datingProfile.media[mediaItemIndex].mediaItemURL, setVideoThumbnail, setVideoDuration)
      }
    }

  }, [videoItemShouldReload, openMediaItemSelectModal])

  // Drag and Drop
  const nullRef = useRef(null) // Disable drag and drop on mobile
  const ref = useRef(null)

  // Executes the drag/drop for the heir draft planning
  const moveMediaItem = (dragIndex, hoverIndex, datingProfile, setDatingProfile, mediaItemId, modifyInDatabase) => {
    // console.log('dragIndex ->', dragIndex)
    // console.log('hoverIndex ->', hoverIndex)
    // console.log('media item ->', mediaItem)

    const draggedMediaItem = { ...datingProfile.media[dragIndex] }
    // console.log('draggedMediaItem ->', draggedMediaItem)

    const newMediaArray = [ ...datingProfile.media ]
    // console.log('beginning ->', newMediaArray)

    // Delete old item
    newMediaArray.splice(dragIndex, 1)
    // console.log('after delete ->', newMediaArray)

    // Add it at the hover index
    newMediaArray.splice(hoverIndex, 0, draggedMediaItem)
    // console.log('after add ->', newMediaArray)


    // Set State
    // console.log('before set ->', newMediaArray)
    setDatingProfile({ ...datingProfile, media: newMediaArray })

    // Video item thumbnail needs to reload when dragged and dropped
    setVideoItemShouldReload(!videoItemShouldReload)

  }

  // Drop Handler
  const [{ handlerId }, drop] = useDrop({
    
    // Component Type (lower case)
    accept: 'editmediaitem',
    
    // Monitoring
    collect(monitor) {
      return {
        handlerId: monitor.getHandlerId(),
      }
    },

    // Hover Handler
    hover(item, monitor) {
      if (!ref.current) {
        return
      }
      // console.log('drop item ->', item)
      const dragIndex = item.mediaItemIndex // Start index
      // console.log('dragIndex ->', dragIndex)
      const hoverIndex = mediaItemIndex // Index that's being hovered over
      // console.log('hoverIndex ->', hoverIndex)
      // console.log('media length ->', datingProfile.media.length)

      // Don't replace items with themselves; don't place an image at an index below the length the media tiems array
      if (dragIndex === hoverIndex || hoverIndex >= (datingProfile.media.length) || hoverIndex < 0) {
        // console.log('out of scope')
        return
      }

      // Determine rectangle on screen
      const hoverBoundingRect = ref.current?.getBoundingClientRect()
      // Get vertical middle
      const hoverMiddleY =
        (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2
      // Determine mouse position
      const clientOffset = monitor.getClientOffset()
      // Get pixels to the top
      const hoverClientY = clientOffset.y - hoverBoundingRect.top

      // Time to actually perform the action
      console.log('moveMediaItem should run')
      moveMediaItem(dragIndex, hoverIndex, datingProfile, setDatingProfile, item.mediaItemId, modifyInDatabase)

      // Note: we're mutating the monitor item here!
      // Generally it's better to avoid mutations,
      // but it's good here for the sake of performance
      // to avoid expensive index searches.
      item.mediaItemIndex = hoverIndex
    },
  })

  // Drag Handler
  const [{ isDragging }, drag, preview] = useDrag({
    
    // Component Type (lower case)
    type: 'editmediaitem',

    // Item properties to retrieve
    item: () => {
      // console.log('is dragging')
      return { mediaItemIndex }
    },

    // Monitor
    collect: (monitor) => ({
      // console.log('is monitoring')
      isDragging: monitor.isDragging(),
    }),
  })

  // Combine it all — Set the drag and drop to the ref
  drag(drop(ref))


  return (
    <>
      <Box
        sx={{
          // mr: 1,
          // mt: 1,
          p: .25,
          position: 'absolute',
          width: datingProfile.type === 'hinge' ? mediaItemDimension(width) : (.75 * parseFloat(mediaItemDimension(width))),
          display: 'flex', flexDirection: 'row', justifyContent: 'flex-end',
        }}
      >
        <IconButton 
          aria-label="delete-media-text" 
          name={`deleteMediaText`}
          className={`delete-media-text`} 
          disabled={tapDisabled()}
          onClick={(e) => handleDeleteItem(e, mediaItemIndex)}
          sx={{ 
            opacity: '80%',
            backgroundColor: 'white',
            height: '20px', width: '20px', 
            border: 1, 
            borderColor: 'black', 
            borderRadius: '50%', 
            cursor: 'pointer',
            '&:hover': { 
              backgroundColor: swipelyticsTurquoise, 
            },
          }} 
        >
          <CloseOutlinedIcon 
            fontSize="small" 
            sx={{ 
              color: 'red',  
            }}
          />
        </IconButton>
      </Box>
      {/* {console.log('datingProfile.media[mediaItemIndex] ->', datingProfile.media[mediaItemIndex])} */}
      {/* {console.log('mediaItemThumbnail' in datingProfile.media[mediaItemIndex] && datingProfile.media[mediaItemIndex].mediaItemThumbnail.length > 0 && datingProfile.media[mediaItemIndex].mediaItemThumbnail !== 'NA' ? datingProfile.media[mediaItemIndex].mediaItemThumbnail : false)} */}
      <Box 
        ref={loading.prompts ? nullRef : ref} // Drag/drop enabled
        onClick={(e) => datingProfile.type === 'hinge' && handleSelectItem(e, mediaItemIndex)}
        disabled={tapDisabled()}
        sx={{ 
          // my: 1,
          width: datingProfile.type === 'hinge' ? mediaItemDimension(width) : (.75 * parseFloat(mediaItemDimension(width))),
          height: mediaItemDimension(width),
          backgroundImage: datingProfile.media[mediaItemIndex].mediaType === 'image' ? `url(${datingProfile.media[mediaItemIndex].mediaItemURL})` : 'mediaItemThumbnail' in datingProfile.media[mediaItemIndex] && datingProfile.media[mediaItemIndex].mediaItemThumbnail.length > 0 && datingProfile.media[mediaItemIndex].mediaItemThumbnail !== 'NA' ? `url(${datingProfile.media[mediaItemIndex].mediaItemThumbnail})` : `url(${videoThumbnail !== null ? videoThumbnail : ''})`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          boxShadow: 3, 
          borderRadius: '5px', 
          cursor: tapDisabled() ? '' : 'pointer',
          display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', alignItems: 'flex-end', 
        }}
      >
        {(('mediaItemDuration' in datingProfile.media[mediaItemIndex] && datingProfile.media[mediaItemIndex].mediaItemDuration > 0) || videoDuration >= 0) && datingProfile.media[mediaItemIndex].mediaType === 'video' &&
          <Box
            sx={{
              my: 1, mx: 1,
              backgroundColor: 'white',
              opacity: 0.8,
              fontSize: '14px',
              width: '30px', maxWidth: '30px',
              display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center',
            }}
          >
            {('mediaItemDuration' in datingProfile.media[mediaItemIndex] && datingProfile.media[mediaItemIndex].mediaItemDuration > 0) ? datingProfile.media[mediaItemIndex].mediaItemDuration : videoDuration}s
          </Box>
        }
      </Box>
    </>

  )
}

export default EditMediaItem